import application from 'application/application';

import moment from 'moment';

const controller = 'DefaultMovementsDetailsManyController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'$stateParams',
	'$timeout',
	'API',
	'helper',
	'notification',
	'authentication',
	'permissions',
	'environment',
	'googleAPI',
	'downloadService',
	'integracaoGoogleCalendar', //aqui google agenda
	'$location',
	'$filter',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		$timeout,
		API,
		helper,
		notification,
		authentication,
		permissions,
		environment,
		googleAPI,
		downloadService,
		integracaoGoogleCalendar, //aqui google agenda
		$location,
		$filter
	) => {
		$scope.stateParams = $.extend({}, $stateParams);

		// const agendaPermission = permissions.get('schedule');

		$scope.productAdvise = authentication.getUserData('idProdutoAdvise');

		$scope.movements = helper.responseStore().setItemsPerPage(20);

		$scope.agendas = helper.responseStore();

		$scope.eventsTypes = helper.responseStore();
		$scope.eventsNotifications = helper.responseStore();

		$scope.selectedType = null;

		$scope.movementInAction = null;

		$scope.disableMailDetail = false;

		$scope.schedulePermission = false;

		$scope.itemCheckedDisabled = true;

		$scope.quantityPerPage = 20;

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');

		$scope.googleSync = localStorage.getItem('gapi') == 'false';

		if ($scope.groupUserSelected == null || $scope.groupUserSelected == 'false')
			$scope.groupUserSelected = false;

		$scope.userData = JSON.parse(
			localStorage.getItem('__authenticationUserData__')
		);

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		$scope.printing = false;

		$scope.valueAllOfAccount = JSON.parse(
			sessionStorage.getItem('__allOfAccount__')
		);

		const dataSyncGoogle = integracaoGoogleCalendar.recoverInfos();

		$rootScope.noSync =
			dataSyncGoogle && dataSyncGoogle.sincronizado ? false : true;

		$scope.shouldDeleteDeadlineType = 'publicação'; // publicação, andamento
		$scope.shouldDeleteDeadlineOption = 1;

		$scope.deleteMultiple = false;

		$scope.isMobile =
			window && window.innerWidth && window.innerWidth <= 991 ? true : false;

		// Data do dia em cadastrar prazo
		let defaultEmptyData = {
			_dia: moment().format('DD/MM/YYYY')
		};

		$rootScope.formCreatePrazo.taskToEdit = helper.cloneSimpleObject(
			defaultEmptyData
		);

		permissions.loadPermissions().then(() => {
			$scope.schedulePermission = permissions.has('recordSchedule');
			$scope.processPermission = permissions.has('createMovements');
		});

		$scope.currentPageUrl = () => {
			const url = $location.$$url.split('/detalhar')[0];

			switch (url) {
				case '/movimentacoes/publicacoes/pastas':
					$scope.environmentPageMov = '3';
					break;
				case '/movimentacoes/publicacoes':
					$scope.environmentPageMov = '2';
					break;
				case '/movimentacoes/processos/pastas':
					$scope.environmentPageMov = '4';
					break;
				case '/movimentacoes/todas-conta':
					$scope.environmentPageMov = '1';
					break;
				default:
					break;
			}
		};

		$scope.currentPageUrl();
		$rootScope.verifyEnvironment($scope.environmentPageMov);

		$scope.tooltipSendEmail = 'Adicione mais emails separando por ";"';

		$scope.getScopedInputValue = scopedInput =>
			scopedInput && scopedInput.$viewValue;

		$scope.printAll = false;

		$scope.downloadingAll = false;

		$scope.printingItems = [];

		$scope.downloadingItems = [];

		$scope.pagination = {
			paginaAtual: 0,
			totalItens: 0,
			quantiaPorPagina: 0,
			hasNext: false
		};

		$scope.tituloModal = '';
		$scope.botaoConfirmarModal = '';
		$scope.mensagemModal = '';

		$scope.titleConfirmation = '';
		$scope.buttonDenyConfirmation = '';
		$scope.buttonConfirmation = '';
		$scope.messageConfirmation = '';

		if (!$scope.stateParams.movements) history.back();

		$scope.onInit = () => {
			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			} else {
				$scope.fetchDeadlineNotification();
			}
		};

		$scope.fetchDeadlineNotification = async () => {
			await $rootScope.fetchDeadlineNotificationId();

			let getEventsNotifications = sessionStorage.getItem(
				'__EVENTS_NOTIFICATIONS__'
			);

			if (getEventsNotifications) {
				let eventsNotificationsTypes = JSON.parse(
					getEventsNotifications || '[]'
				);

				if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
					$scope.eventsNotifications.setItems(eventsNotificationsTypes);
					$scope.eventsNotifications.setReady(true);
				}
			}
		};

		$scope.recordAgendas = responseStore => {
			const idUsuarioCliente =
				parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
				undefined;

			$http({
				...helper.http(API.agendas, 'GET'),
				params: {
					...helper.httpFields(['id']),
					idUsuarioCliente: idUsuarioCliente
				}
			}).then(response => responseStore.setItems(response.data.itens));
		};

		$scope.recordEventsTypes = responseStore => {
			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			$http({
				...helper.http(API.eventsTypes, 'GET'),
				params: {
					...helper.httpFields(['id,nome']),
					idCliente,
					ativo: true
				}
			}).then(({ data }) => {
				responseStore.setItems(data.itens);

				// Converte o array para uma string e armazena no Session Storage
				sessionStorage.setItem(
					'__EVENTS_TYPES__',
					JSON.stringify(responseStore.getItems())
				);

				$rootScope.formCreatePrazo.eventsTypes = responseStore;

				$scope.selectedType = data.itens.find(item => item.nome == 'Prazo');
			});
		};

		$scope.getAllMovements = async () => {
			const url = $location.$$url;

			if (
				(url.contains('/movimentacoes/publicacoes') &&
					!permissions.has('recordPublications')) ||
				(url.contains('/movimentacoes/processos') &&
					!permissions.has('createMovements'))
			) {
				$scope.processMovements.setReady(true);

				$state.transitionTo('root.default.initial', {
					inherit: false,
					reload: true
				});

				return;
			}

			$scope.movements.setNotReady();
			if (
				$scope.stateParams.titulo == '' ||
				$scope.stateParams.titulo == undefined
			) {
				$scope.searchIcon = true;
			} else if ($scope.stateParams.titulo != '') {
				$scope.searchIcon = false;
				$scope.verifySearch = true;
			} else {
				$scope.searchIcon = true;
			}

			const quantity = (await $scope.recordParametersUsers()) || 20;

			const ids = $scope.stateParams.movements;

			const registrosTotal = $scope.stateParams.movements.match(/,/g);

			if (registrosTotal.length + 1 == quantity) {
				$scope.movements.setCurrentPage(1);
			}

			$http({
				...helper.http(API.movementsClients, 'GET'),
				params: {
					...helper.httpFields(['*']),
					ordenacao: '-dataHoraInclusao',
					paginaAtual: $scope.movements.getCurrentPage(),
					registrosPorPagina: quantity,
					possuiDataLixeira: false,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					ids,
					pesquisa: $scope.stateParams.titulo,
					...$scope.movements.getFilters()
				}
			})
				.then(({ data: { itens, paginacao } }) => {
					$scope.movements.setItems(itens);

					const limiteTexto = 250000;

					for (let movement in $scope.movements.items) {
						if (
							$scope.movements.items[movement] &&
							$scope.movements.items[movement].movimento &&
							$scope.movements.items[movement].movimento.publicacao
						) {
							const desc =
								$scope.movements.items[movement].movimento.publicacao
									.conteudo || '';

							if (desc.length > limiteTexto) {
								let limitedText = desc.slice(0, limiteTexto) + '…';

								$scope.movements.items[
									movement
								].movimento.publicacao.conteudoResumo = limitedText;

								$scope.movements.items[movement].movimento.mostrarResumo = 1;
							} else {
								$scope.movements.items[movement].movimento.mostrarResumo = 0;
							}
						}

						if (
							$scope.movements.items[movement] &&
							$scope.movements.items[movement].movimento &&
							$scope.movements.items[movement].movimento.andamentoProcesso
						) {
							const desc =
								$scope.movements.items[movement].movimento.andamentoProcesso
									.descricaoAndamento || '';

							if (desc.length > limiteTexto) {
								let limitedText = desc.slice(0, limiteTexto) + '…';

								$scope.movements.items[
									movement
								].movimento.andamentoProcesso.descricaoAndamentoResumo = limitedText;

								$scope.movements.items[movement].movimento.mostrarResumo = 1;
							} else {
								$scope.movements.items[movement].movimento.mostrarResumo = 0;
							}
						}
					}

					const { paginaAtual, registrosTotal, paginaTotal } = paginacao;

					$scope.movementsLength = registrosTotal || 0;

					$scope.movementsPagesLength = paginaTotal;

					if ($scope.movements.length > 0) $scope.setConfirmationModal();

					$.extend($scope.pagination, {
						paginaAtual: paginaAtual,
						quantiaPorPagina: quantity,
						hasNext: paginaAtual < $scope.movementsPagesLength,
						totalItens: registrosTotal || 0
					});

					$scope.hasItems();
				})
				.finally(() => $scope.movements.setReady(true));
		};

		$scope.hasItems = () => {
			if ($scope.movements.hasNotItems() && !$stateParams.titulo)
				$scope.hideSearch = true;
		};

		// Fecha modal de exluir movimentações
		$scope.closeModal = () => {
			$scope.itemCheckedDisable = false;
			$('.modal').modal('hide');
		};

		$scope.removeSearchIcon = () => {
			if ($scope.verifySearch == true) {
				$scope.searchIcon = true;
			}
		};

		$scope.handleSearch = (filter, clear) => {
			if (filter) {
				var nome = filter.trim();
				var nomeLenghtSpacesShort = nome.replace(/\s/g, '').length;
				var nomeLenghtSpaces = nome.length;

				if (
					(nomeLenghtSpacesShort < 3 && filter != '') ||
					nomeLenghtSpaces >= 301
				) {
					$scope.searchTextual();
					document.getElementById('pesqDetails').focus();

					return;
				}
			}

			$scope.stateParams.titulo = filter;

			$scope.stateParams.paginaAtual = 1;

			if (clear) $scope.stateParams.titulo = '';

			if (!!$scope.stateParams.titulo) {
				$scope.searchIcon = false;
				$scope.verifySearch = true;
			}

			// if (filter != undefined) $scope.getAllMovements();

			$state.go(
				`root.default.movements.list${$scope.environmentPageMov}.details`,
				$scope.stateParams,
				{
					inherit: false
				}
			);
		};

		//************ Chama pararametros de usuarios *************************

		$scope.recordParametersUsers = () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			if (record) {
				$scope.parameterUsers = record;

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				$scope.quantityPerPage = $scope.parameterUsers.qtdRegistroMovPorPagina
					? $scope.parameterUsers.qtdRegistroMovPorPagina
					: 20;

				return $scope.quantityPerPage;
			}

			$http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			}).then(({ data: { itens } }) => {
				if (itens.length) {
					$scope.parameterUsers = itens[0];
					$scope.parameterUsers.idTipoVisualizacao = itens[0].idTipoVisualizacao
						? itens[0].idTipoVisualizacao
						: -1;
					itens[0];
					$scope.parameterUsers.qtdRegistroMovPorPagina = itens[0]
						.qtdRegistroMovPorPagina
						? itens[0].qtdRegistroMovPorPagina
						: 20;
				} else {
					$scope.parameterUsers = {
						qtdRegistroMovPorPagina: 20,
						idTipoVisualizacao: -1,
						exibirInfo: true
					};
				}

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				$scope.quantityPerPage =
					$scope.parameterUsers.qtdRegistroMovPorPagina || 20;

				sessionStorage.setItem(
					'parametros-usuarios',
					JSON.stringify($scope.parameterUsers)
				);
			});
		};

		//************************** FIM dos MÉTODOS **************************

		$scope.updateQuantityPerPage = quantityPerPage => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			$scope.idQtdItensPagina = $scope.idQtdItensPagina
				? $scope.idQtdItensPagina
				: record.idParamUsuarioProdAdv;

			let method = $scope.idQtdItensPagina ? 'PUT' : 'POST';

			$scope.quantityPerPage = quantityPerPage;

			$http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [
						{
							id: record.idParamUsuarioProdAdv,
							qtdRegistroMovPorPagina: quantityPerPage || 20
						}
					]
				},
				messageOverride: {
					success() {}
				}
			}).then(() => {
				$scope.stateParams = helper.cloneSimpleObject($stateParams);
				$scope.stateParams.paginaAtual = 1;

				record.qtdRegistroMovPorPagina = quantityPerPage || 20;

				sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

				$state.go(
					`root.default.movements.list${$scope.environmentPageMov}.details`,
					$scope.stateParams,
					{
						inherit: false,
						reload: true
					}
				);
			});
		};

		$scope.toggleCheck = (checkedItems, id, checkall) => {
			const element = document.getElementById(id);

			const itemChecked = element.checked;

			if (checkall == true && checkedItems == 0) {
				$scope.itemCheckedDisabled = false;
				$scope.itemChecked = true;
				$(
					'.custom-control.custom-checkbox input[type=checkbox] input[id=show-again]'
				).prop('checked', true);
			} else if (checkall == true && checkedItems > 0) {
				$scope.itemCheckedDisabled = true;
			}

			if (itemChecked && checkedItems >= 1) {
				$scope.itemCheckedDisabled = false;
				$scope.itemChecked = true;
				if (checkall) {
					$(
						'.custom-control.custom-checkbox input[type=checkbox] input[id=show-again]'
					).prop('checked', true);
				}
			} else if (checkall != true) {
				if (!checkall && checkedItems == 2) $scope.itemCheckedDisabled = true;
				if (checkedItems > 1 && !checkall) return;
				$scope.itemChecked = false;
			} else if (checkall == true && checkedItems > 0) {
				if (checkedItems > 1 && !checkall) return;
				$scope.itemChecked = false;
			}

			if (itemChecked && checkedItems == 0 && checkall != true) {
				$scope.itemChecked = true;
				$scope.itemCheckedDisabled = true;
			}
		};

		$scope.goBack = () => {
			const notReads = $scope.movements
				.getItems()
				.some(movement => !movement.lido);

			if (notReads) {
				$timeout(() => {
					$scope.setConfirmationModal();
					$('#modalReadConfirmation').modal('show');
				}, 250);
			} else {
				$scope.goBackMov();
			}
		};

		$scope.goBackMov = () => {
			let params = helper.cloneSimpleObject($stateParams);
			let clear = ['paginaAtual', 'movements', 'titulo'];

			clear.forEach(d => {
				delete params[d];
			});

			!$scope.movements.items.length && $rootScope.cleanSelectedMov();

			$state.go(
				`root.default.movements.list${$scope.environmentPageMov}`,
				params,
				{
					inherit: false,
					reload: `root.default.movements.list${$scope.environmentPageMov}`
				}
			);

			$rootScope.updateValues('setMovements');

			$rootScope.getTotalNotRead();
		};

		$scope.openGenericModal = (movement, id, action, fn = () => {}) => {
			if (action) $scope.movementInAction = movement;
			else if (!action) {
				$scope.movementInAction = $scope.movements.getCheckedItems();
			}

			if (id == '#modalSendEmailComponent') {
				$rootScope.configSendEmail.action =
					$scope.movementInAction || $scope.movements.getCheckedItems();
				$rootScope.configSendEmail.route = 'movements';
				$rootScope.configSendEmail.title = 'Enviar por email';
			}

			if (id === '#modalDeleteMovementNew') {
				$rootScope.getDaysDeleteTrash();

				if (movement && !movement.length) {
					$scope.shouldDeleteDeadlineType = !!movement.movimento
						.andamentoProcesso
						? 'andamento'
						: 'publicação';

					if (
						movement.movimento.prazosAvencer ||
						movement.movimento.prazosVencido
					) {
						id = '#modalDeleteMovementWithDeadline';
					}
				} else {
					let movementsChecked = $scope.movements.getCheckedItems();

					if (
						((movement && !movement.length) || !movement) &&
						movementsChecked.length
					) {
						let hasProcess = false;
						let hasPublication = false;

						for (let i = 0; i < movementsChecked.length; i++) {
							if (movementsChecked[i].movimento.andamentoProcesso) {
								hasProcess = true;
							} else if (movementsChecked[i].movimento.publicacao) {
								hasPublication = true;
							}

							if (
								movementsChecked[i].movimento.prazosAvencer ||
								movementsChecked[i].movimento.prazosVencido
							) {
								id = '#modalDeleteMovementWithDeadline';
							}
						}

						if (hasProcess && hasPublication) {
							$scope.shouldDeleteDeadlineType = 'movimentos';
						} else if (hasProcess) {
							$scope.shouldDeleteDeadlineType = 'andamentos';
						} else if (hasPublication) {
							$scope.shouldDeleteDeadlineType = 'publicações';
						}
					} else {
						let hasProcess = false;
						let hasPublication = false;

						for (let i = 0; i < movement.length; i++) {
							if (movement[i].movimento.andamentoProcesso) {
								hasProcess = true;
							} else if (movement[i].movimento.publicacao) {
								hasPublication = true;
							}

							if (
								movement[i].movimento.prazosAvencer ||
								movement[i].movimento.prazosVencido
							) {
								id = '#modalDeleteMovementWithDeadline';
							}
						}

						if (hasProcess && hasPublication) {
							$scope.shouldDeleteDeadlineType = 'movimentos';
						} else if (hasProcess) {
							$scope.shouldDeleteDeadlineType = 'andamentos';
						} else if (hasPublication) {
							$scope.shouldDeleteDeadlineType = 'publicações';
						}
					}
				}
			}

			if (id === '#modalForwardMovements') {
				$timeout(function() {
					document.getElementById('inputCreateEmail').focus();
				}, 500);
			}

			$('.modal').modal('hide');

			fn;

			const el = $(id);

			el.modal && el.modal('show');
		};

		$rootScope.formCreatePrazo.getEventComponent = () => {
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		};

		/** Criar prazo*/
		$scope.createAgendaEvent = async form => {
			$rootScope.creationEventLoading = true;

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			$scope.googleSync = dataSync.sincronizado;

			if ($rootScope.idAgenda === undefined) {
				await $scope.recordAgendas();
			}

			const fields = [
				'titulo',
				'dataHora',
				'dataHoraInicio',
				'diaInteiro',
				'idLembrete',
				'idOpcaoLembreteAgenda',
				'idRepetEventoAgenda',
				'localizacao',
				// 'observacao',
				'idTipoEventoAgenda',
				'idMovProcessoCliente',
				'sincronizado'
			];

			let [
				titulo,
				dataHora = `${new Date().getHours()}:30`,
				dataHoraInicio = new Date().toLocaleDateString('pt-BR'),
				diaInteiro,
				idOpcaoLembreteAgenda = $rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.idNotificacaoCompromisso
					? $rootScope.formCreatePrazo.idNotificacaoCompromisso
					: -1,
				idRepetEventoAgenda = -1,
				localizacao,
				idProcesso,
				// observacao,
				idTipoEventoAgenda,
				idMovProcessoCliente,
				sincronizado
			] = fields.map(input => $scope.getScopedInputValue(form[input]));

			if (form['localizacao']) {
				localizacao = $scope.getScopedInputValue(form['localizacao']);
			}

			if (
				$rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.taskToEdit &&
				$rootScope.formCreatePrazo.taskToEdit.processo
			) {
				idProcesso =
					$rootScope.formCreatePrazo.taskToEdit.processo.idProcesso || null;
			}

			const endHour = $scope.getScopedInputValue(form.dataHoraFim);

			let importante, remoto, presencial;

			if (form && form['importante']) {
				importante =
					form['importante'].$viewValue || form['importante'].$modelValue;
			}

			if (form && form['presencial']) {
				presencial =
					form['presencial'].$viewValue || form['presencial'].$modelValue;
			}

			if (form && form['remoto']) {
				remoto = form['remoto'].$viewValue || form['remoto'].$modelValue;
			}

			const eventDate = `${dataHoraInicio.substr(3, 2)}-${dataHoraInicio.substr(
				0,
				2
			)}-${dataHoraInicio.substr(6)}`;

			let fixDate = eventDate.replace('-', '/').replace('-', '/');

			const initialDate = new Date(`${fixDate} ${dataHora}`);

			if (diaInteiro == true || dataHora == '') {
				dataHora = '23:59:59';
			}

			const finalDate = new Date(`${fixDate} ${dataHora}`);

			const HoraAtual = new Date();

			HoraAtual.setHours(HoraAtual.getHours());

			const hour = parseInt(dataHora.substr(0, 2), 10);

			if (hour >= 23) finalDate.setHours(23, 59);
			else if (diaInteiro) {
				finalDate.setHours(23, 59);
			} else {
				finalDate.setHours(endHour.substr(0, 2), endHour.substr(3, 2));
			}

			if (!$scope.validationHours(initialDate, finalDate)) return;

			const checkbox = document.querySelector(
				'#modalCreateAgendaEvent #sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				sincronizado = checkbox.checked;
			}

			const event = {
				titulo,
				dataHoraInicio: moment(initialDate).format('YYYY-MM-DDTHH:mm:ss'),
				dataHoraFim: moment(finalDate).format('YYYY-MM-DDTHH:mm:ss'),
				idAgenda: $rootScope.idAgenda
					? $rootScope.idAgenda
					: $scope.agendas.getItems()[0].id,
				diaInteiro,
				idOpcaoLembreteAgenda,
				idRepetEventoAgenda,
				importante,
				localizacao,
				idProcesso,
				observacao: $rootScope.formCreatePrazo.taskToEdit.observacao,
				idTipoEventoAgenda,
				sincronizado: $scope.googleSync ? !sincronizado : false,
				idsMovProcessosVinculados: [
					{
						idMovProcessoCliente: idMovProcessoCliente
							? idMovProcessoCliente
							: $scope.movementInAction.idMovProcessoCliente
					}
				],
				remoto,
				presencial
			};

			if (event.sincronizado) {
				await integracaoGoogleCalendar.insertGoogleEvent(event, fields, form);

				setTimeout(() => {
					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('createEvent')();
				}, 300);
			} else {
				delete event['eventoGoogleId'];

				$scope.sendEvent(event, fields, form);
			}
		};

		$scope.sendEvent = (event, fields, form) => {
			return $http({
				...helper.http(API.deadlineEvents, 'POST'),
				data: { itens: [event] },
				messageOverride: {
					success(response, notify) {
						let idTipoEventoAgenda = -3;

						if (
							response &&
							response.data &&
							response.data.itens &&
							response.data.itens[0] &&
							response.data.itens[0].idTipoEventoAgenda
						) {
							idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
						}

						let nameType =
							idTipoEventoAgenda == -3
								? 'Compromisso'
								: idTipoEventoAgenda == -1
								? 'Tarefa'
								: 'Prazo';

						notify.success(
							`${nameType} cadastrad${
								idTipoEventoAgenda == -1 ? 'a' : 'o'
							} com sucesso.`
						);
					}
				}
			})
				.then(() => {
					fields.map(inputKey =>
						helper.defer(() => {
							const $control = form[inputKey];

							if ($control) {
								switch (inputKey) {
									case 'idRepetEventoAgenda':
									case 'idOpcaoLembreteAgenda':
										$control.$setViewValue(-1);
										break;
									case 'idTipoCompromisso':
										$control.$setViewValue('');
										$control.$$ngModelSet('');
										$control.$$setModelValue('');
										break;
									case 'diaInteiro':
										$control.$setViewValue(false);
										$control.$$ngModelSet(false);
										$control.$$setModelValue(false);
										break;
									case 'dataHoraInicio':
										$control.$setViewValue(moment().format('DD/MM/YYYY'));
										break;
									case 'idTipoEventoAgenda':
									case 'idMovProcessoCliente':
										break;
									default:
										$control.$setViewValue('');
										break;
								}

								$control.$render();
							}
						})
					);

					$rootScope.formCreatePrazo.taskToEdit.processo = {};
					$scope.$resetFormValidation('createEvent')();

					$('#modalCreateAgendaEvent').modal('hide');
				})
				.finally(() => ($rootScope.creationEventLoading = false));
		};

		$scope.recordIntegration = async () => {
			//Recupera dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			//aqui google agenda
			if (!$scope.dataSync)
				await integracaoGoogleCalendar.permissionIntegracao();
			//Recupera os dados de sincronização
			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
			$rootScope.sincronizacaoError =
				$scope.dataSync && !!$scope.dataSync.error;
			if ($scope.dataSync && $scope.dataSync.sincronizado) {
				$rootScope.emailGoogleAccount = true;
				$rootScope.emailGoogle = $scope.dataSync.email;
				$scope.sync = true;
			} else {
				$rootScope.emailGoogleAccount = $rootScope.sincronizacaoError
					? true
					: false;
				$rootScope.emailGoogle = false;
			}
			if ($rootScope.sincronizacaoError)
				$('#modalDisabledGoogleCalendarError').modal('show');
		};
		$timeout(() => {
			$('#modalRecoverPastDeadlinesOneComponent').on(
				'hidden.bs.modal',
				function() {
					if ($rootScope.recoverPastDeadlinesClosingFromChoice) {
						$scope.sync = false;

						return;
					}

					if ($rootScope.formCreatePrazo.modalOpen == 'modalCreate') {
						$('#modalCreateAgendaEventComponent').modal('show');
					} else if ($rootScope.formCreatePrazo.modalOpen == 'modalEdit') {
						$('#modalEditTerm').modal('show');
					} else if ($rootScope.formCreatePrazo.modalOpen == 'modalSync') {
						$('#modalSyncAgenda').modal('show');
					}
					$scope.sync = false;
				}
			);
		}, 5000);
		$scope.recordIntegration();

		$scope.checkSyncDeadlines = async (fn, movement) => {
			if (
				movement &&
				movement.movimento &&
				movement.movimento.andamentoProcesso &&
				movement.movimento.andamentoProcesso.idProcesso &&
				movement.movimento.andamentoProcesso.numeroProcesso
			) {
				$rootScope.formCreatePrazo.taskToEdit.processo = {
					id: movement.movimento.andamentoProcesso.idProcesso,
					nome: movement.movimento.andamentoProcesso.numeroProcesso,
					fixado: true
				};

				if (
					movement.movimento.pastas &&
					movement.movimento.pastas.length > 0 &&
					movement.movimento.pastas[0].nome
				) {
					$rootScope.formCreatePrazo.taskToEdit.processo.nome =
						movement.movimento.pastas[0].nome;
				}
			}

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				//Variavel que guarda se ta sincronizado ou não
				$scope.googleSync = dataSync.sincronizado;
				//Guarda intimação a ser vinculada com prazo
				$scope.movementInAction = movement;
				$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
					{
						idMovProcessoCliente: $scope.movementInAction.idMovProcessoCliente
					}
				];
				//Variavel que guarda se ta sincronizado ou não, de forma geral '$rootScope'
				$rootScope.noSync = !dataSync.sincronizado ? true : false;

				//Verifica se e para mostrar mensagem de sincronização
				const showMessage = !integracaoGoogleCalendar.notAgainSincGoogleAgenda();

				if (!$scope.googleSync && showMessage)
					$('#modalSyncAgenda').modal('show');
				else {
					$scope.modalAddEvent();

					fn(movement);
				}
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				$scope.guardDataPrazos = {
					func: fn,
					mov: movement
				};
			}
		};

		//Dessincroniza quando da erro na sincronização
		$scope.disconnectSyncError = async () => {
			$scope.loadingDisconnectError = true;

			let dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendarError').modal('hide');

			$scope.loadingDisconnectError = false;
			$rootScope.sincronizacaoError = false;

			$scope.checkSyncDeadlines(
				$scope.guardDataPrazos.func,
				$scope.guardDataPrazos.mov
			);
		};

		/************* METODO PARA PASSAR EVENTO PRA SINCRONIZADO *************/
		$scope.modalAddEvent = () => {
			$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
		};
		/******************************** FIM ********************************/

		$scope.checkGoogleSync = () => ($scope.googleSync = true);

		$scope.showAgain = localStorage.getItem('__showSyncMessage__') || true;

		$scope.openCreateAgendaEventModal = movement => {
			if (
				$scope.schedulePermission &&
				$scope.agendas.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				$scope.recordAgendas($scope.agendas);
				$scope.recordEventsTypes($scope.eventsTypes);
			}

			$scope.movementsPrazo = { ...movement };
			$('#modalCreateAgendaEventComponent').modal('show');
		};

		/* Impressão de movimentos */
		$scope.printMovements = movement => {
			$scope.printing = true;
			$scope.printAll = true;

			$scope.movementInAction = movement ? movement : null;

			const checkedItems = $scope.movements.getCheckedItems();

			if (!movement && !checkedItems.length)
				return notification.danger('Nenhum movimento selecionado.');

			const ids = movement
				? movement.movimento.id.toString()
				: checkedItems.map(x => x.movimento.id).join();

			$scope.printingItems = [...ids.split(','), ...$scope.printingItems];

			$http({
				...helper.http(API.downloads, 'movements'),
				params: {
					ids,
					tipoArquivo: 'pdf',
					quebrarPaginaImpressao: false,
					idGrupoMovimento:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				},
				responseType: 'blob',
				noCancelOnRouteChange: true
			})
				.then(async response => {
					const { data, status } = response;

					const prevIframes = document.querySelectorAll(
						'.__printable-pdf-frame'
					);

					if (prevIframes.length)
						prevIframes.forEach(iframe => iframe.remove());

					if (status > 299)
						return notification.danger('Erro ao imprimir movimentações.');

					const file = new Blob([data], { type: 'application/pdf' });

					await file.dataURL().then(() => {
						if (navigator.userAgent.indexOf('Chrome') !== -1) {
							const iframe = document.createElement('iframe');

							iframe.className = '__printable-pdf-frame';

							iframe.src = URL.createObjectURL(file);

							document.body.appendChild(iframe);

							iframe.contentWindow.focus();

							setTimeout(() => iframe.contentWindow.print(), 1);
						}
						const isIe = /*@cc_on!@*/ false || !!document.documentMode;

						if (isIe)
							window.navigator.msSaveOrOpenBlob(
								file,
								'msSaveBlob_testFile.pdf'
							);

						if (navigator.userAgent.indexOf('Firefox') !== -1) {
							let newWindow = window.open(
								URL.createObjectURL(file),
								'name',
								'height=800,width=1000'
							);

							newWindow.focus();

							setTimeout(() => newWindow.print(), 2000);
						}
					});
				})
				.finally(() => {
					$scope.printAll = false;
					$scope.printing = false;
					const hasUnread = movement
						? !movement.lido
						: checkedItems.some(item => !item.lido);

					if (hasUnread)
						$timeout(() => $('#modalToggleAsReadDetails').modal('show'), 1500);
				});
		};

		/* Integração de Downloads */
		$scope.downloadMovements = (fileType = 'pdf') => {
			$('#modalDownload').modal('hide');

			const movement = $scope.movementInAction;
			const checkedItems = $scope.movements.getCheckedItems();

			if (!movement && !checkedItems.length)
				return notification.danger('Nenhum movimento selecionado.');

			const ids = movement
				? movement.movimento.id.toString()
				: checkedItems.map(x => x.movimento.id).join();

			$scope.downloadingAll = true;

			$scope.downloadingItems = [...ids.split(','), ...$scope.downloadingItems];

			notification.success('Download iniciado! Isso pode levar algum tempo.');

			const params = {
				ids,
				tipoArquivo: fileType,
				idGrupoMovimento:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			setTimeout(() => {
				const hasUnread = movement
					? !movement.lido
					: checkedItems.some(item => !item.lido);

				if (hasUnread) $('#modalToggleAsReadDetails').modal('show');
			}, 300);

			const api = 'movements';

			downloadService.serviceDownload(params, api);

			$scope.downloadingAll = false;
			$scope.downloadingItems = $scope.downloadingItems.filter(
				item => !ids.split(',').includes(item)
			);
		};

		/* Deletar movimento */
		$scope.deleteMovements = () => {
			$scope.itemCheckedDisabled = true;
			const movement = $scope.movementInAction;
			const movements = movement
				? [movement]
				: $scope.movements.getCheckedItems();

			const checked = movement ? 1 : $scope.movements.getCheckedItems().length;
			const tipo = movement ? movement.movimento.idTipoMovProcesso : null;

			let mensagemSucesso =
				checked > 1
					? 'As movimentações foram excluidas!'
					: 'A movimentação foi exluida!';

			if (tipo)
				mensagemSucesso =
					tipo == -1
						? 'O andamento foi excluído!'
						: 'A publicação foi excluída!';

			const objData = movements.map(movement => {
				let movData = {
					idMovimentoProcessoCliente: movement.movimento.id
				};

				if ($scope.groupUserSelected)
					movData.idGrupoUsuarios = $scope.groupData.idGrupo;
				else movData.idUsuarioCliente = $scope.userData.idUsuarioCliente;

				return movData;
			});

			$http({
				...helper.http(API.briefcase, 'DELETE'),
				method: 'PUT',
				data: objData,
				messageOverride: {
					success(response, notify) {
						notify.success(mensagemSucesso);
					}
				},
				noCancelOnRouteChange: true
			}).then(() => {
				$scope.itemChecked = false;
				$scope.movementInAction = null;

				$rootScope.updateValues();
				$scope.getAllMovements();
			});
		};

		$scope.markAsRead = (movement, all = false) => {
			const movements = movement
				? [movement]
				: all
				? $scope.movements.getItems().filter(item => !item.lido)
				: $scope.movements.getCheckedItems().filter(item => !item.lido);

			const movementsData = movements.map(movement => {
				let movementData = {
					id: movement.id,
					idMovProcessoCliente: movement.idMovProcessoCliente
				};

				if ($scope.groupUserSelected)
					movementData.idGrupoUsuarios = $scope.groupData.idGrupo;

				return movementData;
			});

			if (movementsData.length)
				$http({
					...helper.http(API.movementMarkAsRead, 'PUT'),
					data: {
						itens: movementsData
					},
					messageOverride: {
						success(response, notify) {
							const message =
								movementsData.length > 1
									? 'As movimentações foram marcadas como lidas!'
									: 'A movimentação foi marcada como lida!';

							notify.success(message);
						}
					}
				}).then(() => {
					movements.map(item => $.extend(item, { lido: true }));

					$('.modal').modal('hide');

					// $rootScope.getTotalNotRead();

					if (all) $timeout(() => $scope.goBackMov(), 250);
				});
			else {
				$('.modal').modal('hide');

				if (all) $timeout(() => $scope.goBackMov(), 250);
			}
		};

		$scope.setDeleteModal = movement => {
			const tipo = movement ? movement.movimento.idTipoMovProcesso : null;
			const checked = movement ? 1 : $scope.movements.getCheckedItems().length;

			$scope.movementInAction = movement || null;

			$timeout(() => {
				$scope.mensagemModal =
					'Ao excluir movimentações, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
				$scope.tituloModal =
					checked > 1
						? 'Deseja excluir as movimentações?'
						: 'Deseja excluir a movimentação?';
				$scope.botaoConfirmarModal =
					checked > 1
						? 'Sim, quero excluir as movimentações'
						: 'Sim, quero excluir a movimentação';

				if (tipo == -1) {
					$scope.mensagemModal =
						'Ao excluir um andamento, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível';
					if (checked <= 1) {
						$scope.tituloModal = 'Deseja excluir o andamento?';
						$scope.botaoConfirmarModal = 'Sim, quero excluir o andamento';
					}
				} else if (tipo == -2) {
					if (checked <= 1) {
						$scope.tituloModal = 'Deseja excluir a publicação';
						$scope.botaoConfirmarModal = 'Sim, quero excluir a publicação';
					}
					$scope.mensagemModal =
						'Ao excluir uma publicação, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';
				}
			}, 0);
		};

		$scope.setConfirmationModal = () => {
			const movements = $scope.movements.getItems();

			$timeout(() => {
				if (movements.length > 1) {
					$scope.titleConfirmation =
						'Deseja marcar as movimentações como lidas?';
					$scope.messageConfirmation =
						'Ao marcá-las como lidas, você altera a situação destas movimentações na listagem. Você poderá marcá-las novamente como não lidas selecionando múltiplas ou individualmente.';
					$scope.buttonDenyConfirmation = 'Não, manter como não lidas';
					$scope.buttonConfirmation = 'Sim, quero marcar como lidas';
				} else {
					const tipo = movements[0].movimento.idTipoMovProcesso;

					if (tipo == -1) {
						$scope.titleConfirmation = 'Deseja marcar o andamento como lido?';
						$scope.messageConfirmation =
							'Ao marcá-lo como lido, você altera a situação deste andamento na listagem. Você poderá marcá-lo novamente como não lido individualmente.';
						$scope.buttonDenyConfirmation = 'Não, manter como não lido';
						$scope.buttonConfirmation = 'Sim, quero marcar como lido';
					} else {
						$scope.titleConfirmation = 'Deseja marcar a publicação como lida?';
						$scope.messageConfirmation =
							'Ao marcá-la como lida, você altera a situação desta publicação na listagem. Você poderá marcá-la novamente como não lida individualmente.';
						$scope.buttonDenyConfirmation = 'Não, manter como não lida';
						$scope.buttonConfirmation = 'Sim, quero marcar como lida';
					}
				}
			}, 0);
		};

		$scope.checkPrinting = id => $scope.printingItems.some(item => item == id);

		$scope.checkDownloading = id =>
			$scope.downloadingItems.some(item => item == id);

		$scope.denyRead = () => {
			$('.modal').modal('hide');

			$timeout(() => $scope.goBackMov(), 250);
		};

		$scope.getAllMovements();

		$scope.allProccesses = [];

		$scope.showAllProccess = ({ numero, processosPublicacoes }) => {
			$scope.allProccesses = [];

			if (numero) {
				$scope.allProccesses.push({
					numeroProcesso: numero
				});

				let replaceNumber = numero.replaceAll(/\D+/g, '');

				$scope.allProccesses = [
					...$scope.allProccesses,
					...processosPublicacoes.filter(({ numeroCNJ, numeroProcesso }) =>
						numeroCNJ
							? numeroProcesso !== replaceNumber
							: numeroProcesso !== numero
					)
				];
			} else {
				$scope.allProccesses = processosPublicacoes;
			}

			$('#container-all-proccess').modal('show');
		};

		$scope.markAsReadAfterAction = () => {
			$timeout(() => {
				const movement = $scope.movementInAction;

				$scope.markAsRead(movement, false);

				$scope.itemChecked = false;
				$scope.movementInAction = null;
				$scope.printing = false;
				$scope.printAll = false;

				$scope.itemCheckedDisabled = true;

				const checkedItems = $scope.movements.getCheckedItems();

				checkedItems.forEach(movement => (movement.__checked__ = false));

				$rootScope.cleanSelectedMov();
			}, 500);
		};

		$scope.declineMarkAsRead = () => {
			const checkedItems = $scope.movements.getCheckedItems();

			checkedItems.forEach(movement => (movement.__checked__ = false));

			$scope.itemChecked = false;
			$scope.movementInAction = null;
			$scope.printing = false;
			$scope.printAll = false;

			$('#modalToggleAsReadDetails').modal('hide');
			$scope.itemCheckedDisabled = true;

			$rootScope.cleanSelectedMov();
		};

		// ##############PÁGINAÇÃO#################

		$scope.hasDetailPrevPage = () =>
			($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		$scope.hasDetailLastPage = () =>
			($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) <
			$scope.movementsPagesLength;
		/**
		 * Navega para a primeira página.
		 */
		$scope.recordDetailFirstPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			$state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Navega para a ultima página.
		 */
		$scope.recordDetailLastPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = $scope.movementsPagesLength;

			$state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Navega para a página anterior.
		 */
		$scope.recordDetailPrevPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			let currentPage = params.paginaAtual ? Number(params.paginaAtual) : 1;

			params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

			$state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Navega para a próxima página.
		 */
		$scope.recordDetailNextPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = params.paginaAtual
				? Number(params.paginaAtual) + 1
				: 2;

			$state.go($state.current.name, params, { inherit: false });
		};

		$stateParams.paginaAtual &&
			$scope.movements.setCurrentPage($stateParams.paginaAtual);

		$scope.restoreOrSend = (movements, request) => {
			if (!$scope.send) $scope.sendOrRestoreTrashCan(movements, request);
		};

		//Metodo que envia ou restaura movimento (ambiente de lixeira)
		$scope.sendOrRestoreTrashCan = (movements, request) => {
			if ($scope.send) return;

			$scope.send = true;

			let all =
				$scope.movements.getCheckedItems().length ===
				$scope.pagination.totalItens
					? true
					: false;

			const movement = movements.length ? [...movements] : [movements];

			const objData = movement.map(movement => {
				let movData = {
					idPasta:
						movement.pastasMovimento && movement.pastasMovimento.length > 0
							? movement.pastasMovimento[0].id
							: movement.movimento.pastas &&
							  movement.movimento.pastas.length > 0
							? movement.movimento.pastas[0].idPastaUsuarioCliente
							: null,
					idMovimentoProcessoCliente: movement.movimento.id
				};

				if ($scope.groupUserSelected)
					movData.idGrupoUsuarios = $scope.groupData.idGrupo;
				else movData.idUsuarioCliente = $scope.userData.idUsuarioCliente;

				movData.excluirPrazosVinculados = false;

				if (
					(movement.movimento.prazosAvencer ||
						movement.movimento.prazosVencido ||
						movement.movimento.prazosVencidos) &&
					$scope.shouldDeleteDeadlineOption == 2
				) {
					movData.excluirPrazosVinculados = true;
				}

				if (movement.movimento.idTipoMovProcesso == -1 && !movData.idPasta) {
					if (
						movement.pastasMovimento &&
						movement.pastasMovimento.length > 0 &&
						movement.pastasMovimento[0].id != null
					) {
						movData.idPasta = movement.pastasMovimento[0].id;
					} else if (
						movement.movimento.pastas &&
						movement.movimento.pastas.length > 0 &&
						movement.movimento.pastas[0].idPastaUsuarioCliente != null
					) {
						movData.idPasta =
							movement.movimento.pastas[0].idPastaUsuarioCliente;
					}
				}

				return movData;
			});

			const parseStorage = (storage, key, defaultValue) => {
				try {
					const value = storage.getItem(key);

					return value == null ? defaultValue : JSON.parse(value);
				} catch (error) {
					return defaultValue;
				}
			};
			const uniqueIds = ids =>
				ids
					.map(id => Number(id))
					.filter(
						(id, index, items) =>
							Number.isFinite(id) && id > 0 && items.indexOf(id) == index
					);
			const getIdsPastasPalavrasChave = palavrasChave =>
				uniqueIds(
					palavrasChave.map(
						palavraChave =>
							palavraChave.idPastaUsuarioCliente || palavraChave.id
					)
				);
			const getPalavrasChaveSelecionadas = () => {
				const palavrasChave = parseStorage(
					localStorage,
					'__keywordsChecked__',
					[]
				);

				if (palavrasChave.length) return palavrasChave;

				const selecionados = parseStorage(sessionStorage, '__selected__', {});
				const idsPalavrasChave = String(selecionados.IdsPalavraChave || '')
					.split(',')
					.filter(id => id);
				const palavrasChaveMenu =
					$rootScope.keyWordsMovements && $rootScope.keyWordsMovements.getItems
						? $rootScope.keyWordsMovements.getItems()
						: $rootScope.keyWordsMovements && $rootScope.keyWordsMovements.items
						? $rootScope.keyWordsMovements.items
						: [];

				return idsPalavrasChave
					.map(idPalavraChave =>
						palavrasChaveMenu.find(
							palavraChave => palavraChave.idPalavraChave == idPalavraChave
						)
					)
					.filter(palavraChave => palavraChave);
			};

			const palavrasChaveSelecionadas = getPalavrasChaveSelecionadas();
			const pastaModulo = sessionStorage.getItem('modulo-pasta');
			const idPastaAberta =
				$stateParams.pasta != null ? $stateParams.pasta : pastaModulo;
			const emTodasConta = $location.$$url.includes(
				'/movimentacoes/todas-conta'
			);
			const emPublicacoes = $location.$$url.includes(
				'/movimentacoes/publicacoes'
			);
			const emPastaPublicacao =
				$stateParams.folderType == -2 ||
				$location.$$url.includes('/movimentacoes/publicacoes/pastas') ||
				(parseStorage(sessionStorage, '__publicationPaste__', false) &&
					idPastaAberta != null);
			const possuiFiltroPalavraChave =
				(emTodasConta || emPublicacoes) && palavrasChaveSelecionadas.length > 0;
			const enviarPorPasta =
				request == 'send' && (emPastaPublicacao || possuiFiltroPalavraChave);

			let idsPastas = [];

			if (emPastaPublicacao && idPastaAberta != null)
				idsPastas = uniqueIds([idPastaAberta]);
			else if (possuiFiltroPalavraChave)
				idsPastas = getIdsPastasPalavrasChave(palavrasChaveSelecionadas);

			if (enviarPorPasta && idsPastas.length == 0)
				idsPastas = uniqueIds(objData.map(item => item.idPasta));

			const payload = {
				movimentosXPastas: objData.map(item => {
					const movimentoXPasta = { ...item };

					delete movimentoXPasta.idPasta;

					return movimentoXPasta;
				}),
				idsPastas
			};

			$http({
				...helper.http(
					API.trashCan,
					enviarPorPasta ? 'sendByFolders' : `${request}`
				),
				method: 'PUT',
				data: enviarPorPasta ? payload : objData,
				messageOverride: {
					success(response, notify) {
						const success =
							request == 'send'
								? 'Enviado para a Lixeira!'
								: 'Documento restaurado!';

						notify.success(success);
					},
					error(response, notify) {
						const error =
							request == 'send'
								? 'Erro ao enviar para Lixeira.'
								: 'Erro ao restaurar documento.';

						notify.danger(error);
					}
				},
				noCancelOnRouteChange: true
			})
				.then(response => {
					if (response.status != 500) {
						$scope.itemChecked = false;
						$scope.movementInAction = null;
						$scope.itemCheckedDisabled = true;

						$rootScope.updateValues('setMovements');

						$scope.getAllMovements();

						if (all) {
							$rootScope.cleanSelectedMov();

							let params = helper.cloneSimpleObject($stateParams);

							params.paginaAtual = null;

							$state.transitionTo(
								`root.default.movements.list${$scope.environmentPageMov}`,
								params,
								{
									inherit: false,
									reload: `root.default.movements.list${$scope.environmentPageMov}`
								}
							);

							$('.modal').modal('hide');

							$scope.send = false;
						} else if (!all) {
							$('.modal').modal('hide');

							if ($rootScope.newPublicationChecked) {
								$rootScope.newPublicationChecked.forEach(mark => {
									movement.forEach(mov => {
										if (mark.idMovProcessoCliente === mov.idMovProcessoCliente)
											mark.excluir = true;
									});
								});

								$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
									mov => mov.excluir
								);
							}

							if (
								$scope.movements.getCheckedItems().length &&
								$scope.quantityPerPage
							) {
								let params = helper.cloneSimpleObject($stateParams);

								params.paginaAtual = 1;

								$state.transitionTo(
									`root.default.movements.list${$scope.environmentPageMov}.details`,
									params,
									{
										inherit: false,
										reload: `root.default.movements.list${$scope.environmentPageMov}.details`
									}
								);
							}

							setTimeout(() => {
								$scope.send = false;
							}, 10);
						}
					} else if (response.status == 500) {
						$('.modal').modal('hide');
						notification.danger('Erro ao enviar para Lixeira.');

						setTimeout(() => {
							$scope.send = false;
						}, 10);
					}
				})
				.catch(() => {
					$scope.send = false;
				});
		};

		$scope.validationHours = (sDate, eDate) => {
			const startDate = moment(sDate);
			const endDate = moment(eDate);

			if (!startDate.isValid() || !endDate.isValid()) {
				notification.danger('Informe horários válidos para o compromisso.');

				$rootScope.creationEventLoading = false;

				return false;
			}

			if (endDate.isSameOrBefore(startDate)) {
				notification.danger(
					'Hora final cadastrada no compromisso não pode ser menor ou igual à hora inicial!'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			const diffInMinutes = endDate.diff(startDate, 'minutes');

			if (diffInMinutes < 15) {
				notification.danger(
					'O intervalo mínimo entre o horário de início e fim é de 15 minutos.'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			return true;
		};

		$scope.getTextCopy = (movement, type1, type2) => {
			if (type1) {
				const name =
					$filter('formatToCNJ')(movement.movimento.pastas[0].nome) || '';

				const numberProcPubli =
					$filter('formatToCNJ')(
						movement.movimento.andamentoProcesso.numeroProcesso
					) || '';

				return !!name ? name : numberProcPubli;
			}
			if (type2) {
				const numberProc =
					$filter('formatToCNJ')(movement.movimento.publicacao.numero) || '';

				return numberProc;
			}

			return '';
		};

		$scope.getColorCopy = (type1, type2) => {
			if (type1) return '#1097b3';
			if (type2) return '#d32f2f';

			return '#000';
		};

		$scope.getColorHoverCopy = (type1, type2) => {
			if (type1) return '#0c697a';
			if (type2) return '#9a0007';

			return '#000';
		};

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});

		$scope.popover = false;
		$scope.invalidName = false;
		$scope.searchTextual = event => {
			let el1 = document.getElementById('pesqDetails');

			var nome = el1.value.trim();
			var nomeLenghtSpacesShort = nome.replace(/\s/g, '').length;
			var nomeLenghtSpaces = nome.length;

			if (nomeLenghtSpacesShort < 3 && event != 'blur' && el1.value != '') {
				el1.classList.add('search__input-invalid');
				$scope.popover = true;
				$scope.invalidName = true;
				$scope.popoverMax = false;
			} else if (nomeLenghtSpaces >= 301) {
				el1.classList.add('search__input-invalid');
				$scope.popover = true;
				$scope.invalidName = true;
				$scope.popoverMax = true;
			} else {
				$scope.popover = false;
				event != 'blur' && el1.classList.remove('search__input-invalid');
			}

			if (!el1.classList.contains('search__input-invalid'))
				$scope.invalidName = false;

			if (event == 'blur') $scope.popover = false;
		};

		$scope.attachmentDownload = async (
			attachmentId,
			fileType = 'pdf',
			printing,
			movement
		) => {
			$scope.printing = true;

			await downloadService.attachmentDownload(
				attachmentId,
				fileType,
				printing,
				movement
			);

			$scope.printing = false;
		};

		$scope.movementToggleShow = (movement, toggle) => {
			if (toggle) {
				movement.movimento.mostrarResumo = 2;
			} else {
				movement.movimento.mostrarResumo = 1;
			}
		};

		$scope.onInit();
	}
]);

export default controller;
